(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw26-signup-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw26-signup')) {
  customElements.define('aw26-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const track = this.querySelector('.aw-signup__track');
      const frames = [...this.querySelectorAll('.aw-signup__frame')];
      const counter = this.querySelector('.aw-signup__count');
      const buttons = [...this.querySelectorAll('[data-step]')];
      if (!counter || !frames.length) return;
      const current = () => frames.reduce((best, frame, index) => Math.abs(frame.getBoundingClientRect().left - track.getBoundingClientRect().left) < Math.abs(frames[best].getBoundingClientRect().left - track.getBoundingClientRect().left) ? index : best, 0);
      const update = () => {
        const i = current();
        counter.textContent = (i + 1) + ' / ' + frames.length;
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const i = Math.max(0, Math.min(frames.length - 1, current() + Number(button.dataset.step)));
        track.scrollBy({left: frames[i].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-selection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-selection')) {
  customElements.define('lb-selection', class extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('lb-selection--carousel') || this.abort) return;
      this.abort = new AbortController();
      const track = this.querySelector('.lb-selection__track');
      const cards = [...track.children];
      const buttons = [...this.querySelectorAll('[data-direction]')];
      const update = () => {
        const bounds = track.getBoundingClientRect();
        const visible = cards.map((card,i) => ({i,rect:card.getBoundingClientRect()})).filter(({rect}) => rect.right > bounds.left + 2 && rect.left < bounds.right - 2);
        this.querySelector('.lb-selection__status').textContent = visible.length ? `${visible[0].i + 1}–${visible[visible.length-1].i + 1} / ${cards.length}` : '';
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const step = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        const visibleCount = Math.max(1,Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).columnGap) + 1) / step));
        track.scrollBy({left:Number(button.dataset.direction)*step*visibleCount,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      },{signal:this.abort.signal}));
      track.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});
      this.observer = new ResizeObserver(update);this.observer.observe(track);
      this.setAttribute('data-ready','');update();
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
